import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { GeneralInformationContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getVendors, getCompanies } from 'ducks/options'
import { getVendorContacts } from 'ducks/bankGuarantee'
import { options } from '../../../../AttributeData'

const GeneralInformation = (props) => {
  const { valueForm={}, change, members, memberLoading, vendorOptions, companyOptions, 
    isDisplay=false, editMode=false } = props
  const [showGeneralInfo, setShowGeneralInfo] = useState(true)
  
  useEffect(() => {
    props.getAllMembers(isDisplay)
    // props.getHrmsMembers(isDisplay)

    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const onGetVendorContactSuccess = (data) => {
    change('vendorContacts', data)
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='General Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowGeneralInfo(!showGeneralInfo) }>
            {showGeneralInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showGeneralInfo}>
        <CardContent>
          <GeneralInformationContainer>
            <div className='rowFields'>
              <Field 
                name='title' 
                label='Title' 
                require 
                editable={editableForm() || editMode} 
                type={type.text} 
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='remark' 
                label='Remark' 
                editable={editableForm() || editMode} 
                type={type.textArea} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='vendorCode' 
                label='Vendor' 
                require
                options={vendorOptions.data} 
                loading={vendorOptions.loading} 
                editable={editableForm() && 
                  valueForm.createType === 'original' &&
                  (valueForm.references || []).length === 0} 
                specialOnChange={(value) => {
                  if (value && valueForm.companyCode) {
                    props.getVendorContacts(value, valueForm.companyCode, onGetVendorContactSuccess)
                  }
                }} 
                type={type.select} 
                component={FieldInput} 
              />
              <Field 
                name='companyCode' 
                label='Company'
                require 
                options={companyOptions.data} 
                loading={companyOptions.loading}
                editable={editableForm() && 
                  valueForm.createType === 'original' &&
                  (valueForm.references || []).length === 0}
                specialOnChange={(value) => {
                  if (value && valueForm.vendorCode) {
                    props.getVendorContacts(valueForm.vendorCode, value, onGetVendorContactSuccess)
                  }
                  change('projectManagerUser', '')
                }} 
                type={type.select} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='typeOfBond' 
                label='Type of Bond' 
                require
                options={options.typeOfBond} 
                loading={false} 
                editable={(editableForm() || editMode) && 
                  valueForm.createType === 'original' && 
                  (valueForm.references || []).length === 0}
                specialOnChange={(value) => {
                  change('otherTypeOfBond', '')
                }}
                type={type.select} 
                component={FieldInput} 
              />
              <Field 
                name='amount' 
                label='Amount (THB)' 
                require
                allowNegative={false}
                editable={editableForm() && valueForm.createType === 'original'}  
                type={type.number} 
                component={FieldInput} 
              />
            </div>
            {
              valueForm.typeOfBond === 'other' ?
              <div className='rowFields'>
                <Field 
                  name='otherTypeOfBond' 
                  label='Other Type of Bond' 
                  require
                  editable={(editableForm() || editMode) && 
                    valueForm.createType === 'original'}  
                  type={type.text} 
                  component={FieldInput} 
                />
                <Field type={type.empty} component={FieldInput} />
              </div> : null
            }
          </GeneralInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
  })
}
  
const mapDispatchToProps = {
  getHrmsMembers,
  getVendors,
  getCompanies,
  getVendorContacts,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)